import { SceneContainer } from '../components/scene/SceneContainer'
import { useCombinedCalendar, useCurrentWorkspace } from '../store/hooks'
import { ListCalendar } from '../components/calendar/ListCalendar'

const CombinedCalendarScreen = () => {
  const { myWorkspaces } = useCurrentWorkspace()
  const { events, repeatingEvents } = useCombinedCalendar()
  return (
    <SceneContainer title="Calendar" description="View your upcoming deadlines">
      <ListCalendar
        workspaces={myWorkspaces}
        events={events}
        repeatingEvents={repeatingEvents}
        showWorkspaceLabel
        showWorkspaceFilters
        showTaxYearEnd
      />
    </SceneContainer>
  )
}

export default CombinedCalendarScreen
